// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26v-J","title":"Header_title__Vx6-X","side":"Header_side__3AZZk"};